import React, { useState, useEffect } from "react";
import Container from "@material-ui/core/Container";
import Typography from "@material-ui/core/Typography";
import Footer from "../components/Footer";
import TextField from "@material-ui/core/TextField";
import styled from "styled-components";
import Button from "@material-ui/core/Button";
import { useHistory } from "react-router-dom";
import { connect } from "react-redux";
import AuthActions from "../actions/auth.actions";
import bgImg from '../assets/imgs/QR_bg_img.JPG';

const StyledTextField = styled(TextField)`
  margin-bottom: 10px;
  background: transparent;
  border-color: #3f3f3f !important;
  * {
    border-color: #00ffff !important;
  }
  label,
  input {
    color: #fff !important;
  }
`;

const StyledBtn = styled(Button)`
  background: #00ffff !important;
  border-color: #00ffff !important;
  padding-left: 25px;
  padding-right: 25px;
  color: #000;
`;

const StyledContainer = styled.div`
  display: flex;
  justify-content: center;
  padding-top: 50px;
`;

const Home = (props) => {
  const initialFormdata = {
    name: "",
    emailAddress: "",
    password: "",
    confirmPassword: "",
  };
  const [currentState, setCurrentState] = useState("login");
  const [formData, setFormData] = useState(initialFormdata);
  const [otp, setOTP] = useState("");
  let history = useHistory();

  useEffect(() => {
    if (props.auth.access_token && props.auth.isVerified) {
      history.push("/profile");
    }
    if (props.auth.access_token && !props.auth.isVerified) {
      setFormData(initialFormdata);
      setCurrentState("unverified_user");
    }
  }, [props.auth.access_token]);

  function LoginUser() {
    props.loginUser(formData, (userState) => {
      if (userState === "unverified_user") {
        setFormData(initialFormdata);
        setCurrentState("unverified_user");
      } else {
        history.push("/profile");
      }
    });
  }

  function RegisterUser() {
    props.registerUser(formData, () => {
      setFormData(initialFormdata);
      setCurrentState("login");
    });
  }

  function ForgotPassword() {
    props.forgotPassword(formData, () => {
      setFormData(initialFormdata);
      setCurrentState("login");
    });
  }

  function ResendVerificationEmail() {
    props.resendVerificationEmail(formData, () => {
      setFormData(initialFormdata);
      setCurrentState("login");
    });
  }

  function routeToProfile() {
    history.push("/profile");
  }

  return (
    <div style={{ backgroundImage: "url("+bgImg+")", backgroundSize: "cover", minHeight: "100%" }}>
      <Container fixed>
        <Typography
          component="div"
          align="center"
          style={{ paddingTop: "70px" }}
        >
          <h1>
            <span style={{ color: "white" }}>Mystery</span>QR
          </h1>
          <p>Make your campaigns go viral</p>
          <StyledContainer>
            {currentState === "register" && (
              <div
                style={{
                  display: "flex",
                  flexDirection: "column",
                  width: "300px",
                }}
              >
                <StyledTextField
                  id="name"
                  type="text"
                  label="Name"
                  variant="outlined"
                  value={formData.name}
                  onChange={(ev) => {
                    setFormData({
                      ...formData,
                      ...{
                        name: ev.target.value,
                      },
                    });
                  }}
                />
                <StyledTextField
                  id="email"
                  type="email"
                  label="Email Address"
                  variant="outlined"
                  value={formData.emailAddress}
                  onChange={(ev) => {
                    setFormData({
                      ...formData,
                      ...{
                        emailAddress: ev.target.value,
                      },
                    });
                  }}
                />
                <StyledTextField
                  id="password"
                  type="password"
                  label="Password"
                  variant="outlined"
                  value={formData.password}
                  onChange={(ev) => {
                    setFormData({
                      ...formData,
                      ...{
                        password: ev.target.value,
                      },
                    });
                  }}
                />
                <StyledTextField
                  id="confirm_password"
                  type="password"
                  label="Confirm Password"
                  variant="outlined"
                  value={formData.confirmPassword}
                  onChange={(ev) => {
                    setFormData({
                      ...formData,
                      ...{
                        confirmPassword: ev.target.value,
                      },
                    });
                  }}
                />
                <p style={{fontSize: "10px", textAlign: "left"}}>By clicking Register button, you agree with our <a href="https://drive.google.com/file/d/1Ghkl6s3LdxaYU5GieUB_BRalqn4QGSCt/view?usp=sharing" style={{color: "white", fontSize: "10px"}} target="_blank">Privacy Policy</a> and <a style={{color: "white", fontSize: "10px"}} href="https://drive.google.com/file/d/12gev13xDl3iDSE16ibxBipXYr0AYm-hd/view?usp=sharing" target="_blank">Terms of Service</a>.</p>
                <StyledBtn
                  variant="outlined"
                  color="primary"
                  onClick={() => RegisterUser()}
                >
                  Register
                </StyledBtn>
                <div
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                    fontSize: "10px",
                  }}
                >
                  <p
                    style={{ cursor: "pointer" }}
                    onClick={() => {
                      setFormData(initialFormdata);
                      setCurrentState("forgetPassword");
                    }}
                  >
                    Forgot Password ?
                  </p>
                  <p
                    style={{ cursor: "pointer" }}
                    onClick={() => {
                      setFormData(initialFormdata);
                      setCurrentState("login");
                    }}
                  >
                    Login
                  </p>
                </div>
              </div>
            )}
            {currentState === "forgetPassword" && (
              <div
                style={{
                  display: "flex",
                  flexDirection: "column",
                  width: "300px",
                }}
              >
                <StyledTextField
                  id="email"
                  type="email"
                  label="Email Address"
                  variant="outlined"
                  value={formData.emailAddress}
                  onChange={(ev) => {
                    setFormData({
                      ...formData,
                      ...{
                        emailAddress: ev.target.value,
                      },
                    });
                  }}
                />
                <StyledBtn
                  variant="outlined"
                  color="primary"
                  onClick={() => ForgotPassword()}
                >
                  Reset Password
                </StyledBtn>
                <div
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                    fontSize: "10px",
                  }}
                >
                  <p
                    style={{ cursor: "pointer" }}
                    onClick={() => {
                      setFormData(initialFormdata);
                      setCurrentState("login");
                    }}
                  >
                    Login
                  </p>
                  <p
                    style={{ cursor: "pointer" }}
                    onClick={() => {
                      setFormData(initialFormdata);
                      setCurrentState("register");
                    }}
                  >
                    Register
                  </p>
                </div>
              </div>
            )}
            {currentState === "login" && (
              <div
                style={{
                  display: "flex",
                  flexDirection: "column",
                  width: "300px",
                }}
              >
                <StyledTextField
                  id="email"
                  type="email"
                  label="Email Address"
                  variant="outlined"
                  value={formData.emailAddress}
                  onChange={(ev) => {
                    setFormData({
                      ...formData,
                      ...{
                        emailAddress: ev.target.value,
                      },
                    });
                  }}
                />
                <StyledTextField
                  id="password"
                  type="password"
                  label="Password"
                  variant="outlined"
                  value={formData.password}
                  onChange={(ev) => {
                    setFormData({
                      ...formData,
                      ...{
                        password: ev.target.value,
                      },
                    });
                  }}
                />
                <StyledBtn
                  variant="outlined"
                  color="primary"
                  onClick={() => LoginUser()}
                >
                  Login
                </StyledBtn>
                <div
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                    fontSize: "10px",
                  }}
                >
                  <p
                    style={{ cursor: "pointer" }}
                    onClick={() => {
                      setFormData(initialFormdata);
                      setCurrentState("forgetPassword");
                    }}
                  >
                    Forgot Password ?
                  </p>
                  <p
                    style={{ cursor: "pointer" }}
                    onClick={() => {
                      setFormData(initialFormdata);
                      setCurrentState("register");
                    }}
                  >
                    Register
                  </p>
                </div>
              </div>
            )}
            {currentState === "unverified_user" && (
              <div>
                <p>
                  You haven't verified your account yet.
                  <br /> In case you havent received verification email, you can
                  resend verification email below.
                </p>
                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    width: "300px",
                    margin: "auto",
                  }}
                >
                  <StyledTextField
                    id="email"
                    type="email"
                    label="Email Address"
                    variant="outlined"
                    value={formData.emailAddress}
                    onChange={(ev) => {
                      setFormData({
                        ...formData,
                        ...{
                          emailAddress: ev.target.value,
                        },
                      });
                    }}
                  />
                  <StyledBtn
                    variant="outlined"
                    color="primary"
                    onClick={() => ResendVerificationEmail()}
                  >
                    Resend Verification Email
                  </StyledBtn>
                </div>
              </div>
            )}
          </StyledContainer>
        </Typography>
        <Footer />
      </Container>
    </div>
  );
};

const mapStateToProps = (state) => {
  return state;
};

const mapDispatchToProps = (dispatch) => {
  return {
    loginUser: (payload, cb) => dispatch(AuthActions.loginUser(payload, cb)),
    registerUser: (payload, cb) =>
      dispatch(AuthActions.registerUser(payload, cb)),
    forgotPassword: (payload, cb) =>
      dispatch(AuthActions.forgotPassword(payload, cb)),
    resendVerificationEmail: (payload, cb) =>
      dispatch(AuthActions.resendVerificationEmail(payload, cb)),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(Home);
